import { BASE_PATH } from 'src/constants/urls';

export const isAppUrl = (href: string) => {
  const url = href.split(/\?|#/g)[0]; // strip out query params and hash params

  return Boolean(url.includes(BASE_PATH));
};
